import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FlexCenter,
  FlexColumnCenter,
  FlexLeftCenter,
} from "../../constant/CustomeStyle";

const menus = [
  { title: "Add Menu", to: "/add-menu" },
  { title: "Edit Menu", to: "/edit-menu" },
  { title: "Delete Menu", to: "/add-menu" },
];

const RightMenuMenu = () => {
  const [pMenu, setPMenu] = useState("Add Menu");
  const navigate = useNavigate();

  const handleMenu = (text, to) => {
    setPMenu(text);
    navigate(to);
  };

  return (
    <div
      style={{
        width: 206,
        height: 762,
        background: "#333C4B",
      }}
    >
      <TitleBar text={"Search"} />

      <div style={{ minHeight: 60 }}></div>

      <div style={{ minHeight: 250, marginTop: 10 }}>
        <FlexColumnCenter>
          {menus.map((item, index) => (
            <MenuBox
              item={item}
              key={index}
              marginV={10}
              handleMenu={handleMenu}
              menuText={pMenu}
            />
          ))}
        </FlexColumnCenter>
      </div>
    </div>
  );
};

const MenuBox = ({ item, marginV, handleMenu, menuText }) => (
  <FlexLeftCenter
    style={{
      width: 178,
      height: 36,
      border: "1px solid #C4C4C4",
      marginBottom: marginV,
      background: `${
        menuText === item.title
          ? "#CA2129"
          : "linear-gradient(180deg, rgba(75, 83, 98, 0) 0%, #4B5362 100%)"
      }`,
      cursor: "pointer",
    }}
    onClick={() => handleMenu(item.title, item.to)}
  >
    <div
      style={{
        marginLeft: 10,
        color: "#FFF",
        fontSize: 14,
        fontWeight: "600",
        fontFamily: `Poppins, sans-serif`,
      }}
    >
      {item.title}
    </div>
  </FlexLeftCenter>
);

const TitleBar = ({ text }) => (
  <FlexLeftCenter
    style={{
      background: "#CA2129",
      width: 206,
      height: 46,
    }}
  >
    <div
      style={{
        color: "#FFF",
        fontSize: 18,
        fontWeight: "600",
        fontFamily: `Poppins, sans-serif`,
        marginLeft: 20,
      }}
    >
      {text}
    </div>
  </FlexLeftCenter>
);

export default RightMenuMenu;
